import React from 'react'

export default function KapdeDan() {
    return (
        <div>KapdeDan</div>
    )
}
